<script>
  /**
   * Blog component
   */
  export default {
    name: ''
  }
  </script>
  
  <template>
    <!-- START BLOG -->
    <section class="section bg-light" id="blog">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2">
            <h1 class="section-title text-center">Курсове</h1>
            <div class="section-title-border margin-t-20"></div>
            <p
              class="section-subtitle text-muted text-center font-secondary padding-t-30"
            ></p>
          </div>
        </div>
  
        <div class="row margin-t-30" style="justify-content: center;">
          <div class="col-lg-4">
            <div class="blog-box margin-t-30">
              <img src="@/assets/images/fanmath-images/course1.jpg" class="img-fluid rounded" alt />
              <div>
                <h5 class="mt-4 text-muted"></h5>
                <h4 class="mt-3">
                  <a class="blog-title">Курсове за 6-ти клас</a>
                </h4>
                <p style="text-decoration: underline; text-decoration-color: orange;text-underline-offset: 5px"
                  class="text-muted"
                >Целогодишни курсове
                  <br>Пролетен курс
                <br>Пробни изпити</p>
              </div>
            </div>
          </div>
  
          <div class="col-lg-4">
            <div class="blog-box margin-t-30">
              <img src="@/assets/images/fanmath-images/course2.jpg" class="img-fluid rounded" alt />
              <div>
                <h5 class="mt-4 text-muted"></h5>
                <h4 class="mt-3">
                  <a class="blog-title">Курсове за 7-ми клас</a>
                </h4>
                <p style="text-decoration: underline; text-decoration-color: orange;text-underline-offset: 5px"
                  class="text-muted"
                  >Целогодишни курсове
                  <br>Интензивен курс
                <br>Пробни изпити</p>
              </div>
            </div>
          </div>  

        </div>
      </div>
    </section>
    <!-- END BLOG -->
  </template>